module.exports = __webpack_public_path__ + "img/Verkehrslotse.32e905cd.jpg";